import * as React from 'react';

type WindowDimensionsSize = {
  width: number;
  height: number;
};

const useWindowDimensions = (): WindowDimensionsSize => {
  const [windowSize, setWindowSize] = React.useState<WindowDimensionsSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowDimensions;
